import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@app/shared/shared.module';
import { CommonSharedModule } from 'common/common.module';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { DetailInfoCheckboxComponent } from './detail-info-checkbox/detail-info-checkbox.component';
import { DetailInfoDatetimeComponent } from './detail-info-datetime/detail-info-datetime.component';
import { DetailInfoNumericTextboxComponent } from './detail-info-numeric-textbox/detail-info-numeric-textbox.component';
import { DetailInfoRadioComponent } from './detail-info-radio/detail-info-radio.component';
import { DetailInfoSelectComponent } from './detail-info-select/detail-info-select.component';
import { DetailInfoTextareaComponent } from './detail-info-textarea/detail-info-textarea.component';
import { DetailInfoTextboxComponent } from './detail-info-textbox/detail-info-textbox.component';
import { DetailInfoToggleComponent } from './detail-info-toggle/detail-info-toggle.component';
import { DetailInfoTypeContainerComponent } from './detail-info-type-container/detail-info-type-container.component';
import { DetailInfoTypeComponent } from './detail-info-type.component';
import { DetailInfoMultiSelectComponent } from './detail-info-multi-select/detail-info-multi-select.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { DetailInfoTimePickerComponent } from './detail-info-time-picker/detail-info-time-picker.component';
import { DetailInfoSelectWithTextComponent } from './detail-info-select-with-text/detail-info-select-with-text.component';
import { DetailInfoRepeatableTableComponent } from './detail-info-repeatable-table/detail-info-repeatable-table.component';
import { FieldTitleModule } from 'shared/field-title/field-title.module';


@NgModule({
  declarations: [
    DetailInfoTypeComponent,
    DetailInfoTypeContainerComponent,
    DetailInfoCheckboxComponent,
    DetailInfoDatetimeComponent,
    DetailInfoNumericTextboxComponent,
    DetailInfoRadioComponent,
    DetailInfoSelectComponent,
    DetailInfoTextareaComponent,
    DetailInfoTextboxComponent,
    DetailInfoToggleComponent,
    DetailInfoMultiSelectComponent,
    DetailInfoTimePickerComponent,
    DetailInfoSelectWithTextComponent,
    DetailInfoRepeatableTableComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    NgSelectModule,
    PaginationModule.forRoot(),
    CommonSharedModule,
    BsDatepickerModule,
    TimepickerModule.forRoot(),
    FieldTitleModule
  ],
  exports: [DetailInfoTypeContainerComponent, DetailInfoRepeatableTableComponent],
  providers: []
})

export class DetailInfoTypeModule { }
